import { render, staticRenderFns } from "./TypeAction.vue?vue&type=template&id=4d5848dc&"
import script from "./TypeAction.vue?vue&type=script&lang=ts&"
export * from "./TypeAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports